module.exports = __webpack_public_path__ + "img/IntransitMD.db60ad19.png";